import './BasicFilterComponent.scss';

export class BasicFilterComponent {

    static instance = {
        template: require('./BasicFilterComponent.html'),
        controller: [BasicFilterComponent],
        transclude: {
            inputs: 'inputs',
            controls: 'controls'
        }
    };

}